//
//
//
//
//
//

export default {
  props: {
    url: {
      type: String,
      required: true,
    }
  },
  mounted () {
    const script = document.createElement('script')
    script.setAttribute('src', 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js')
    this.$refs.embedScript.appendChild(script)

    window.addEventListener('message', this.handleMessage)
  },
  beforeDestroy () {
    window.removeEventListener('message', this.handleMessage)
  },
  methods: {
    handleMessage (event) {
      if (event?.data?.meetingBookSucceeded) {
        this.$gtm.push({
          event: 'hubspot_meeting_booked'
        })
        this.$ph.capture('meeting_booked')
      }
    }
  }
}
